import { render, staticRenderFns } from "./PopupDeleteGroup.vue?vue&type=template&id=431c9041"
import script from "./PopupDeleteGroup.vue?vue&type=script&lang=js"
export * from "./PopupDeleteGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports